export default {
  state: {
    isAuth: false,
    pip: '',
    apiUrl: 'https://'+window.location.hostname+'/api/'
  },
  mutations: {
    LOGINNING (state, isAuth) {
      state.isAuth = isAuth
    },
    INIT (state, isAuth) {
      state.isAuth = isAuth
    },
    PIPCH (state, pip) {
      state.pip = pip
    }
  },
  actions: {
    LOGINNING({commit}, payload){
      commit('LOGINNING', payload.isauth)
    },
    INIT({commit}, payload){
      commit('INIT', payload.isauth)
    },
    PIPCH({commit}, payload){
      commit('PIPCH', payload.pip)
    }
  },
  getters: {
    isAuthUser: state => state.isAuth,
    apiUrl: state => state.apiUrl,
    pipUser: state => state.pip
  }
}